import React from 'react';
import SkuQuotaMastersProvider from './sku-quota-masters-provider';

export default function withSkuQuotaMasters(WrappedComponent) {
  return function SkuQuotaMastersProviderHOC(props) {
    return (
      <SkuQuotaMastersProvider>
          <WrappedComponent {...props} />
      </SkuQuotaMastersProvider>
    );
  };
};
